<template>
  <div class="c-card white">
    <div>
      <div
        class="c-form-group c-card__error"
        :class="{ 'c-form-group--error': valid.questions.$each.$iter[index].$error }"
      >
        <div class="c-card__question">
          {{body.title}}
        </div>
        <div class="c-card__options">
          <div v-for="(option, oindex) of body.options" :key="`${body.id}-option-${oindex}`">
            <label class="white">
              <span v-if="body.order" class="me-2">{{getOptionIndex(option)}}</span>
              <input
                v-model="model"
                :type="type"
                :value="option"
                :name="body.id">
              {{option}}
            </label>
          </div>

          <div v-if="body.other">
            <label class="white">
              <input
                v-model="model"
                :id="`other-${body.id}`"
                :type="type"
                value="other"
                :name="body.id" />
              <div class="c-option-text">
                <label :for="`other-${body.id}`">Otros</label>
                <input v-model="inputValue" type="text">
              </div>
            </label>
          </div>
        </div>

        <span
          class="c-form-group__error c-error"
          v-if="!valid.questions.$each.$iter[index].answer.required"
        >
          Elija una opcion
        </span>

        <span
          class="c-form-group__error c-error"
          v-if="!valid.questions.$each.$iter[index].answerOther.required"
        >
          Debe detallar su respuesta
        </span>
      </div>
      <div class="c-card__footer d-flex align-items-center">
        <div class="c-card__buttons d-flex">
          <button @click="prevStep()" class="c-button c-button--primary-flat mt-2">
            Anterior
          </button>
          <button @click="nextStep()" class="c-button c-button--primary-flat mt-2">
            {{(body.id === 'Q12') ? 'Enviar' : 'Siguiente'}}
          </button>
        </div>
        <div class="c-card__tag">
          <span class="white">*Obligatorio</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputValue: '',
    };
  },
  props: ['value', 'index', 'type', 'body', 'valid', 'step', 'questionStep', 'lastQuestionStep'],
  watch: {
    index() {
      this.inputValue = this.body.answerOther;
    },
    inputValue() {
      this.$emit('update:body', {
        ...this.body,
        answerOther: this.inputValue,
      });
    },
  },
  computed: {
    model: {
      get() { return this.value; },
      set(newValue) { this.$emit('input', newValue); },
    },
  },
  mounted() {
    if (this.body.other) {
      this.inputValue = this.body.answerOther;
    }
  },
  methods: {
    getOptionIndex(option) {
      return this.body.answer.indexOf(option) + 1;
    },

    prevStep() {
      if (this.index === 0) {
        this.$emit('update:step', this.step - 1);
      } else if (this.lastQuestionStep !== -1) {
        this.$emit('update:questionStep', this.lastQuestionStep);
      } else {
        this.$emit('update:questionStep', this.index - 1);
      }
    },
    nextStep() {
      this.valid.$touch();

      if (!this.valid.questions.$each.$iter[this.index].$error) {
        this.valid.$reset();

        if (this.body.id === 'Q12') {
          this.$emit('update:step', this.step + 1);
        } else if (this.body.jump && this.body.jump.options.includes(this.value)) {
          this.$emit('update:questionStep', this.body.jump.to);
          this.$emit('update:lastQuestionStep', this.index);
        } else {
          this.$emit('update:questionStep', this.index + 1);
          this.$emit('update:lastQuestionStep', -1);
        }
      }
    },
  },
};
</script>
